// extracted by mini-css-extract-plugin
export default {"videoWrapper":"_3ttjqytKdoKKc1mCP5jQ6M","videoContainer":"VS9ys2pomHO5s51DUTEja"};